// Refer & Earn — customer-user referrals (partner-network-service via the
// gateway). Referrer identity always comes from the session token; submission
// carries a client-minted key so retries can never create duplicates.
import { gatewayApi } from '@/lib/hrApi';

export interface ReferralProgramStatus {
  enabled: boolean;
  terms_version: string;
  terms_accepted: boolean;
  can_manage: boolean;
}
export interface MyReferral {
  id: string;
  company_name: string;
  country: string;
  status: string; // simplified user-safe vocabulary
  created_at: string;
}
export interface RewardBucket { currency: string; amount: number }
export interface RewardSummary {
  pending: RewardBucket[]; earned: RewardBucket[]; processing: RewardBucket[]; paid: RewardBucket[];
}
export interface SubmitReferralInput {
  client_key: string;
  company_name: string;
  country: string;
  industry?: string;
  employee_count?: number;
  website?: string;
  contact_name: string;
  contact_title?: string;
  contact_email: string;
  contact_phone?: string;
  relationship?: string;
  notes?: string;
}

export const getReferralProgram = () =>
  gatewayApi.get<ReferralProgramStatus>('/api/v1/referral-program/status').then((r) => r.data);
export const acceptReferralTerms = (country?: string) =>
  gatewayApi.post('/api/v1/referral-program/terms/accept', { country });
export const setReferralProgramEnabled = (enabled: boolean) =>
  gatewayApi.post('/api/v1/referral-program/enabled', { enabled });
export const listMyReferrals = () =>
  gatewayApi.get<{ items: MyReferral[] }>('/api/v1/referrals/me').then((r) => r.data.items ?? []);
export const getMyReferralSummary = () =>
  gatewayApi
    .get<{ open: number; customers_joined: number; total: number; rewards: RewardSummary }>('/api/v1/referrals/me/summary')
    .then((r) => r.data);
export const submitReferral = (input: SubmitReferralInput) =>
  gatewayApi.post<{ id: string; company_name: string; status: string }>('/api/v1/referrals', input).then((r) => r.data);
